import Client from 'client';
import gql from 'graphql-tag';
import { isMatchingTradeGuides } from 'pages/pros/pro-form/pro-form-update-validation-schema';
import { ToastError } from 'utils';
import * as Yup from 'yup';

const isExistingSlug = async (slug?: string | null): Promise<boolean> => {
  return Client.query({
    query: gql`
      query ($slug: String!) {
        proPresentation(where: { slug: { _eq: $slug } }) {
          id
          slug
        }
      }
    `,
    variables: { slug: slug || '' },
  }).then(
    (response) =>
      response.data.proPresentation && response.data.proPresentation.length > 0,
  );
};

export const proFormCreateValidationSchema = (
  action: 'create' | 'create-zone',
) => {
  return Yup.object().shape({
    bilikZoneId: Yup.number().nullable().required(),
    trades: Yup.array().of(Yup.string()).min(1),
    emailTarget: Yup.string()
      .email('Adresse email non valide')
      .required('Adresse mail requise !'),
    geoCoordinates: Yup.object()
      .shape({
        lat: Yup.number(),
        lng: Yup.number(),
      })
      .nullable()
      .required('Coordonnées requises !'),
    proPresentation:
      action === 'create'
        ? Yup.object().shape({
            name: Yup.string()
              .required('Nom de la fiche requis !')
              .test(
                'no-comma',
                "Le nom ne doit pas contenir de virgules (',')",
                (value) => {
                  return !(
                    typeof value === 'string' && value.indexOf(',') !== -1
                  );
                },
              ),
            mainTrades: Yup.array()
              .of(Yup.number().required())
              .min(1, 'Au moins une catégorie principale requise')
              .required()
              .test('is-trade-guide', async (mainTrades) => {
                return isMatchingTradeGuides(mainTrades);
              }),
            slug: Yup.string()
              .required('Slug requis !')
              .matches(/^[a-z0-9-]+$/, {
                excludeEmptyString: true,
                message: 'Format incorrect !',
              })
              .test('is-slug-uniq', 'Slug déjà existant !', async (slug) => {
                return isExistingSlug(slug)
                  .then((res) => res === false)
                  .catch((error) => {
                    ToastError(
                      'Erreur',
                      "Impossible de vérifier l'unicité du slug !",
                    );
                    throw error;
                  });
              }),
          })
        : Yup.object(),
    postalAddress: Yup.object().shape({
      geoCoordinates: Yup.object()
        .shape({
          lat: Yup.number(),
          lng: Yup.number(),
        })
        .nullable()
        .required("Coordonnées de l'adresse de l'entreprise requises !"),
    }),
  });
};
